import {
  Separator,
  Typography,
  AvatarInput,
  TYPOGRAPHY_SIZE,
  ChangePassword,
  LogoutButton,
  BoxExpand,
  SupportRequestsTable,
} from '@thinknet-gmbh/platform-common-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MemberTypesEnum, SubscriptionTypesEnum } from '@thinknet-gmbh/platform-common';

import { useAuth } from 'src/hooks/auth.hooks';
import { useCurrentMemberContext } from 'src/contexts';
import { PASSWORD_PATTERN } from 'src/pages/auth/auth.constants';
import { useChangePassword } from 'src/hooks/accounts/change-password.hook';
import { useGetCurrentAccount } from 'src/hooks/accounts/get-current-account.hook';
import { useUploadProfileAvatar } from 'src/hooks/profiles/upload-profile-avatar.hook';
import { useGetSupportRequests } from 'src/hooks/support-requests/get-support-requests.hook';
import { useUpdateSupportRequest } from 'src/hooks/support-requests/update-support-request.hook';
import { useGetCurrentSubscription } from 'src/hooks/subscriptions/get-current-subscription.hook';
import { useGetCurrentCompanyPosition } from 'src/hooks/company-positions/get-current-company-position.hook';

import { MainInfo } from './components/main-info';
import { ProfileEdit } from './components/profile-edit';
import { ProfileContainer, SupportTableWrapper } from './user-profile.styles';
import { PaymentInformation } from './components/payment-information';

const UserProfile = () => {
  const [isEdit, setIsEdit] = useState(false);
  const { t } = useTranslation('common');

  const uploadProfileAvatar = useUploadProfileAvatar();
  const changePassword = useChangePassword();
  const { type } = useCurrentMemberContext();
  const { subscription } = useGetCurrentSubscription();
  const { loading, paginationConfig, supportRequests } = useGetSupportRequests();
  const updateSupportRequest = useUpdateSupportRequest();
  const onAvatarInputChange = (value: any) => {
    uploadProfileAvatar({ variables: { avatar: value } });
  };

  const onChangePasswordSubmit = (values: any) => {
    changePassword({ variables: values });
  };

  const { companyPosition } = useGetCurrentCompanyPosition();
  const { account, profile } = useGetCurrentAccount();

  const data = {
    companyPosition,
    account,
    profile,
  };

  const { logout } = useAuth();

  return (
    <ProfileContainer>
      <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
        {t('labels.avatar')}
      </Typography>
      <AvatarInput onChange={onAvatarInputChange} avatar={profile.avatarUrl} />
      <Separator />
      {isEdit ? (
        <ProfileEdit data={data} cancelEdit={setIsEdit} />
      ) : (
        <MainInfo data={data} openEdit={setIsEdit} />
      )}
      <Separator />
      <ChangePassword
        t={t}
        onSubmitForm={onChangePasswordSubmit}
        passwordPattern={PASSWORD_PATTERN}
      />

      {type === MemberTypesEnum.OWNER &&
        subscription.subscriptionType !== SubscriptionTypesEnum.INTERNAL && (
          <>
            <Separator />
            <PaymentInformation />
          </>
        )}
      <SupportTableWrapper>
        <BoxExpand
          separator
          title={t('settings:supportTab.mySupportRequest')}
          titleFontSize={TYPOGRAPHY_SIZE.medium}
        >
          <SupportRequestsTable
            t={t}
            loading={loading}
            data={supportRequests}
            paginationConfig={paginationConfig}
            onChangeStatus={(status, _id) =>
              updateSupportRequest({ variables: { payload: { _id, status } } })
            }
          />
        </BoxExpand>
      </SupportTableWrapper>
      <Separator />
      <LogoutButton t={t} logout={logout} />
    </ProfileContainer>
  );
};

export default UserProfile;
